import auth from './auth';
import departments from './departments';
import hardwareModels from './hardware-models';
import providers from './providers';
import softwareModels from './software-models';
import types from './types';
import uid from './uid';
import users from './users';

export default {
    auth,

    departments,
    hardwareModels,
    providers,
    softwareModels,
    types,
    users,
    uid
};
